import api from "../api/client";

const qualPApi = {
  postQualP(payload, idShipper) {
    return api.post("/qualp/routes", payload, {
      params: {
        uidShipper: idShipper,
      },
    });
  },
};

export default qualPApi;
